import { ICategoryResult } from './categories';

export interface ISearchResult {
    title: string;
    url: string;
    revisedDate: Date;
    shortDescription: string;
    friendlyUrl: string;
    viewableByEveryone: boolean;
}

export interface IResults {
    loading: boolean;
    currentPage: number;
    searchItemList: ISearchResult[];
    categories: ICategoryResult[];
    totalNumber: number;
    totalPages: number;
    errorMessage: string;
    errorType: IErrorType;
    showResults: boolean;
    noResultsWYSIWYG: string;
    generativeResult: string;
    generativeResultHeader: string;
    disableGenerativeResult: boolean;
}

export enum IErrorType {
    NONE,
    GENERAL,
    TIME_OUT
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/state-helpers/search-results.ts